import { useEffect, useState } from "react";
import { api, apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";

const REASONS = ["Hardship", "Staff child", "Sibling discount", "Scholarship", "Goodwill / make-good", "Trial day"];

export const WaiveDialog = ({ order, onClose, onDone }) => {
  const [pick, setPick] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { setPick(""); setNote(""); }, [order]);
  const submit = async () => {
    const reason = pick === "Other" ? note.trim() : [pick, note.trim()].filter(Boolean).join(" — ");
    setBusy(true);
    try { await api.post(`/admin/orders/${order.id}/confirm`, { waive: true, reason, reason_category: pick === "Other" ? "Other" : pick }); toast.success("Fee waived & order confirmed"); onDone(); }
    catch (e) { toast.error(apiErr(e)); }
    setBusy(false);
  };
  return (
    <Dialog open={!!order} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="rounded-2xl" data-testid="waive-dialog">
        <DialogHeader><DialogTitle className="font-display text-navy">Waive {order ? `$${Number(order.amount).toFixed(2)}` : ""} for {order?.parent_name}</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500">This confirms the order with nothing to pay. Pick a reason so the Fees Waived report groups it neatly.</p>
        <div className="flex flex-wrap gap-2">
          {[...REASONS, "Other"].map((r) => (
            <button key={r} type="button" onClick={() => setPick(r)} data-testid={`waive-reason-${r.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={`px-3 py-1.5 rounded-full text-xs font-semibold border transition-colors ${pick === r ? "bg-violet-600 text-white border-violet-600" : "bg-white text-navy border-slate-200 hover:border-violet-400"}`}>{r}</button>
          ))}
        </div>
        <Input value={note} onChange={(e) => setNote(e.target.value)} placeholder={pick === "Other" ? "Type the reason…" : "Optional note"} className="rounded-xl" data-testid="waive-note" />
        <div className="flex justify-end gap-2">
          <Button variant="outline" className="rounded-full" onClick={onClose} data-testid="waive-cancel">Cancel</Button>
          <Button disabled={busy || !pick || (pick === "Other" && !note.trim())} onClick={submit} className="rounded-full bg-violet-600 hover:bg-violet-700 text-white" data-testid="waive-submit">Waive fee</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
